/*
 *
 *
 *
 *   Copyright (c) 2022. TinyMedic Pvt Ltd  - All Rights Reserved.
 *   This file is part of the API module  of the project: TinyMedic-Platform.
 *
 *
 *   Proprietary and confidential.
 *
 *   Unauthorized copying of this file, via any medium is strictly prohibited.
 *    Any resources of   TinyMedic-Platform can not be copied and/or distributed without the express permission of TinyMedic Pvt Ltd.
 *
 *
 *
 */

import React from 'react';
import { Route } from 'react-router';

import ErrorBoundaryRoutes from 'app/shared/error/error-boundary-routes';

import LaborProgression from './labor-progression';
import LaborProgressionDetail from './labor-progression-detail';
import LaborProgressionUpdate from './labor-progression-update';
import LaborProgressionDeleteDialog from './labor-progression-delete-dialog';

const LaborProgressionRoutes = () => (
  <ErrorBoundaryRoutes>
    <Route index element={<LaborProgression />} />
    <Route path="new" element={<LaborProgressionUpdate />} />
    <Route path=":id">
      <Route index element={<LaborProgressionDetail />} />
      <Route path="edit" element={<LaborProgressionUpdate />} />
      <Route path="delete" element={<LaborProgressionDeleteDialog />} />
    </Route>
  </ErrorBoundaryRoutes>
);

export default LaborProgressionRoutes;
